import React from 'react';
import { func, array } from 'prop-types';

import CSS from './styles.css';


const FilterHighlightOptionsViews = ({ displayAnnotationColors, onDisplayAnnotationColorChange }) => {
  return (
    <div className={ CSS['card-container'] }>
      <header className={ CSS['card-header'] }>
        <span className={ CSS['card-title'] }>Highlight Color</span>
      </header>
      <div className={ CSS['card-body'] }>
        <ul className={ CSS['list'] }>
          {
            displayAnnotationColors.map(el => {
              const { color, display, disabled, markerId, label } = el;
              return (
                <li key={ markerId } className={ CSS['list-item'] }>
                  <label className={ CSS['label'] } htmlFor={ markerId }></label>
                  <input type="checkbox" id={ markerId } checked={ display } disabled={ disabled } onChange={ onDisplayAnnotationColorChange }/>
                  <svg className={ CSS['svg-circle'] } width="20" height="20" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="10" fill={ color } />
                  </svg>
                  <span className={ CSS['label-text'] }>{ label }</span>
                </li>
              );
            })
          }
        </ul>
      </div>
    </div>
  );
}

FilterHighlightOptionsViews.propTypes = {
  displayAnnotationColors: array,
  onDisplayAnnotationColorChange: func
};


export default FilterHighlightOptionsViews;
